<form [formGroup]="form" (submit)="submitForm()">
  @if (isLoadingStudentInfo) {
    <div class="flex justify-content-center align-items-center p-8">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  } @else {
    <mat-card class="p-4 bg-grey-button form-school-transfer-and-withdrawal-form">
    
      <div class="edit-field my-1">
        <label for="studentName">Student Name</label>
        <input
          id="studentName"
          matInput
          formControlName="studentName"
          aria-readonly="true"
          data-pw="edit_student_name_input"
          data-qa="edit_student_name_input" />
      </div>

      <div class="edit-field my-1">
        <label for="studentPID">Student PID</label>
        <input
          id="studentPID"
          matInput
          formControlName="studentPid"
          [readonly]="true"
          aria-readonly="true"
          data-pw="edit_student_pid_input"
          data-qa="edit_student_pid_input" />
      </div>

      <div class="edit-field my-1">
        <label for="termName">Term</label>
        <input
          id="termName"
          matInput
          formControlName="termName"
          [readonly]="true"
          aria-readonly="true"
          data-pw="edit_term_name_input"
          data-qa="edit_term_name_input" />
      </div>

      <div class="edit-field my-1">
        <label for="reasonForWithdrawal">Reason for Withdrawal</label>
        <mat-form-field>
          <mat-select
            id="reasonForWithdrawal"
            placeholder="Please Select"
            formControlName="reasonForWithdrawal"
            data-pw="edit_reason_for_withdrawal_input"
            data-qa="edit_reason_for_withdrawal_input">
            @for (reason of reasons; track reason) {
              <mat-option [value]="reason.withdrawalReasonId">{{ reason?.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <cfi-form-inline-error [control]="form.get('reasonForWithdrawal')" />
      </div>

      @if (requiresAttendanceDates()) {
        <div class="edit-field my-1">
          <label for="firstDateOfAttendance">First Date of Attendance</label>
          <mat-form-field>
            <input
              id="firstDateOfAttendance"
              matInput
              [matDatepicker]="firstPicker"
              formControlName="firstDateOfAttendance"
              data-pw="edit_first_date_of_attendance_input"
              data-qa="edit_first_date_of_attendance_input" />
            <mat-datepicker-toggle matSuffix [for]="firstPicker"></mat-datepicker-toggle>
            <mat-datepicker #firstPicker></mat-datepicker>
          </mat-form-field>
          <cfi-form-inline-error [control]="form.get('firstDateOfAttendance')" />
        </div>

        <div class="edit-field my-1">
          <label for="lastDateOfAttendance">Last Date of Attendance</label>
          <mat-form-field>
            <input
              id="lastDateOfAttendance"
              matInput
              [matDatepicker]="lastPicker"
              formControlName="lastDateOfAttendance"
              data-pw="edit_last_date_of_attendance_input"
              data-qa="edit_last_date_of_attendance_input" />
            <mat-datepicker-toggle matSuffix [for]="lastPicker"></mat-datepicker-toggle>
            <mat-datepicker #lastPicker></mat-datepicker>
          </mat-form-field>
          <cfi-form-inline-error [control]="form.get('lastDateOfAttendance')" />
        </div>
      }
      @if (!form.disabled) {
        <mat-card-actions align="end" class="mt-5">
          <button mat-flat-button type="submit" [disabled]="!isFormReady() || isSubmitting" color="primary">
            @if (isSubmitting) {
              <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
            }
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </button>
        </mat-card-actions>
      }
    </mat-card>
  }
</form>
